import { createMuiTheme } from "material-ui/styles";
import { blueGrey, cyan } from "material-ui/colors";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2196F3",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#607D8B",
    },
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '"Helvetica Neue"',
      "Roboto",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/styles/theme.js